import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {PetTall} from "../../../Models/PetTall";
import {Gestiones} from "../services/Gestiones";
import {AlertArgumentarioComponent} from "../../VistasGenericas/alert-argumentario/alert-argumentario.component";

@Component({
    selector: 'ral-peticiones_reclamacion_overlay',
    templateUrl: './reclamacion_overlay.component.html',
    styleUrls: ['./reclamacion_overlay.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ReclamacionesOverlay
{
    public petTall: PetTall;
    public motivosAnula: string[][] = [
        ["", "SELECCIONE MOTIVO"],
        ["B", "RAYADO TRANSPORTE FURGONETA"],
        ["D", "ROTO TRANSPORTE FURGONETA"],
        ["E", "FALTA MATERIAL"],
        ["G", "CALIDAD"]
    ];

    public motivosDiccionario: {[key: string]: string;} = {
      "": "SELECCIONE MOTIVO",
      "B": "RAYADO TRANSPORTE FURGONETA",
      "D": "ROTO TRANSPORTE FURGONETA",
      "E": "FALTA MATERIAL",
      "G": "CALIDAD"
    }
    public selectedMotivo: string = "";
    public titulo: string = "";
    public buttonText: string = "";
    public opcion: string = "";

    constructor(public dialogRef: MatDialogRef<ReclamacionesOverlay>,
                private http: HttpClient,
                private dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.petTall = data.petTall;
        this.opcion = data.tipo;
        if (data.tipo == "reclamacion"){
          this.titulo = "Reclamaciones";
          this.buttonText = "Reclamar";
        }else{
          this.titulo = "Devoluciones";
          this.buttonText = "Devolver";
        }
    }

    onClose(operacion: string) {

        if (operacion == "reclaim" && this.selectedMotivo != "") {
            AlertArgumentarioComponent.mostrarArgumentarioRes("OK", ["¿Esta seguro de realizar la " + this.opcion + "?"], true, false, false, this.dialog, true).subscribe(result => {
              if (result){
                this.petTall.par_009 = this.selectedMotivo;
                this.petTall.obser = this.motivosDiccionario[this.selectedMotivo];

                if(this.opcion == "reclamacion"){
                  Gestiones.createReclamacion(this.http, this.petTall.peticio);
                }else{
                  Gestiones.createDevolucion(this.http, this.petTall.peticio);
                }

                this.dialogRef.close(this.petTall);
              }
            });
        }else if(operacion != "reclaim"){
          this.dialogRef.close(null);
        }else{
          AlertArgumentarioComponent.mostrarArgumentario("Error", ["Debes de selecionar un motivo para poder actualizar"], true, true, true, this.dialog);
        }
    }
}
